import { setActiveTab } from '../../actions/activeTab';
import { notify } from '../../actions/notifications';
import { setSavedSearches } from '../../actions/savedSearches/actions';
import { PERS_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT } from '../../constants/experiments';
import { TDesktopGetListResponse, fetchDesktopGetList } from '../../repositories/saved-searches/v1/desktop/get-list';
import { isAbUseExperimentGroup } from '../../selectors/experiments';
import { EFavoritePageType } from '../../types/favoritePageType';
import { ETabType } from '../../types/filters';
import { ENotificationStyle } from '../../types/notifications';
import { TThunkAction } from '../../types/redux';
import { mapSavedSearchesResponse } from '../../utils/mapSavedSearchesResponse';
import { trackPageview } from '../../utils/trackPageview';

export interface IRequestQuery {
  [key: string]: string;
}

export const getSavedSearches =
  (query?: IRequestQuery): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { httpApi, logger }) => {
    const showError = () =>
      dispatch(notify('Не удалось получить список сохраненных соисков', ENotificationStyle.Error));

    const state = getState();

    const {
      user,
      activeTab: { activeTab },
      abUseExperiments,
      page,
    } = state;

    if (typeof window !== 'undefined') {
      trackPageview({ pageData: page, user, favoritePageType: EFavoritePageType.Savedsearch });
    }

    const isSaveSearchExperimentEnabled = isAbUseExperimentGroup(
      abUseExperiments,
      PERS_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT,
      'B',
    );

    const isTabSavedSearches = activeTab === ETabType.SavedSearches || query?.activeTab === ETabType.SavedSearches;

    if (!isSaveSearchExperimentEnabled || !user.isAuthenticated || !isTabSavedSearches) {
      return;
    }

    try {
      const { statusCode, response }: TDesktopGetListResponse = await fetchDesktopGetList({
        httpApi,
        parameters: {
          limit: 10000,
          offset: 0,
        },
      });

      if (statusCode === 200) {
        dispatch(setSavedSearches(mapSavedSearchesResponse(response)));
        dispatch(setActiveTab({ activeTab: ETabType.SavedSearches, isInitialized: true }));
      }

      if (statusCode === 400) {
        showError();
        logger.warning(response.message || 'Failed to get saved searches (400 status code)');
      }
    } catch (e) {
      showError();
      logger.error(e, { description: 'Failed to get saved searches' });
    }
  };
